<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row" style="background: #7bf4ff">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center text-center">
              <img src="@/assets/images/pages/forgot-password.jpg" alt="login" class="mx-auto h-full" style="max-height: 280px" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8" v-if="!verify">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">找回密码</h4>
                  <p>请输入您的手机号，我们将会给您发送验证码，您需要按照指引重置密码</p>
                </div>

                <vx-form layout="h" v-slot="{handleSubmit}">
                  <form-item required hideLabel class="mb-5">
                    <vs-input
                      class="w-full"
                      v-model="phone"
                      icon-no-border
                      icon="iconfont icon-user"
                      icon-pack="feather"
                      placeholder="手机号"
                    />
                  </form-item>
                  <form-item required hideLabel>
                    <vs-row>
                      <vs-col vs-w="6">
                        <vs-input
                          type="text"
                          icon-no-border
                          icon="iconfont icon-notification"
                          icon-pack="feather"
                          placeholder="验证码"
                          v-model="code"
                          class="w-full"
                          @keypress.enter="handleSubmit(verifyCode)"
                        />
                      </vs-col>
                      <vs-col vs-w="6" vs-align="left">
                        <vs-button type="border" size="small" style="margin-top: 3px;" class="ml-1" @click="sendCode" :disabled="!!disabledSendTimeout">发送验证码<span v-if="disabledSendTimeout"> ({{disabledSendTimeout}}) </span></vs-button>
                      </vs-col>
                    </vs-row>
                  </form-item>
                  <div class="flex flex-wrap justify-between mt-5">
                    <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">返回登录</vs-button>
                    <vs-button
                      class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                      @click="handleSubmit(verifyCode)"
                    >提交</vs-button>
                  </div>
                </vx-form>
              </div>
              <div class="p-8" v-else>
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">重置密码</h4>
                  <p>您的邮箱已验证通过，请输入您的新密码后提交</p>
                </div>

                <vs-input
                  type="password"
                  label-placeholder="新密码"
                  v-model="newPassword"
                  class="w-full mb-6"
                />
                <vs-input
                  type="password"
                  label-placeholder="确认新密码"
                  v-model="confirmNewPassword"
                  class="w-full mb-6"
                />

                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">返回登录</vs-button>
                <vs-button
                  class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                  @click="resetPassword"
                >重置密码</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      code: "",
      verify: false,
      token: "",
      newPassword: "",
      confirmNewPassword: "",
      disabledSendTimeout: 0,
    };
  },
  methods: {
    startSendTimeout() {
      this.disabledSendTimeout = 60
      this.interval = setInterval(() => {
        this.disabledSendTimeout--
        if (this.disabledSendTimeout <= 0) {
          this.interval && clearInterval(this.interval)
        }
      }, 1000)
    },
    async sendCode() {
      const data = {
        type: "reset_password",
        phone: this.phone
      };
      await this.$s.auth.createVerifyCode(data);
      this.$notify({
        title: "短信发送成功",
        text: "请查收您的短信，请输入短信内验证码"
      });
      this.startSendTimeout()
    },
    async verifyCode() {
      const data = {
        type: "reset_password",
        phone: this.phone,
        code: this.code
      };
      const res = await this.$s.auth.verifyCode(data);
      this.verify = true;
      this.token = res.token;
      this.$notify({
        title: "验证码验证成功",
        text: "请根据指引重置您的密码"
      });
    },
    async resetPassword() {
      if (this.newPassword != this.confirmNewPassword) {
        this.$notify({
          color: "danger",
          title: "密码不一致",
          text: "请确认您的新密码和确认密码一致"
        });
        return;
      }
      const data = {
        token: this.token,
        newPassword: this.newPassword
      };
      await this.$s.auth.resetPassword(data);
      this.$notify({
        title: "重置密码成功",
        text: "请使用新密码登录"
      });
      this.$router.push('/pages/login')
    }
  }
};
</script>
<style lang="scss" scoped>
.send-code-btn {
  margin-top: 17px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 1rem !important;
}
</style>